<!-- 商户报表详情 -->
<template>
  <div class="comContent body-box">
    <div class="body-title">
      <div class="body-title-left">{{shopName}}</div>
      <div class="body-title-right"><el-button size="small" @click="goBack">返回</el-button></div>
    </div>
    <div class="body-tools">
      <div class="body-tools-left">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <el-form-item label="" prop="">
            <el-input v-model="formTool.erp_id" size="small" placeholder="请输入客户ID" clearable />
          </el-form-item>
          <el-form-item label="" prop="">
            <el-input v-model="formTool.pay_shop_name" size="small" placeholder="请输入客户名称" clearable />
          </el-form-item>
          <el-form-item label="" prop="">
            <el-input v-model="formTool.pay_concat_phone" size="small" placeholder="请输入客户电话" clearable />
          </el-form-item>
          <el-form-item label="" prop="">
            <el-cascader v-model="formTool.pay_district_name" size="small" ref="areaRef" placeholder="请选择所在区域" clearable
            :options="areaTreeData" :props="cascaderProps" @change="areaChange"></el-cascader>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-select v-model="formTool.pay_shop_type_name" size="small" placeholder="请选择客户类型" clearable>
              <el-option v-for="item in typesOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首次下单时间" prop="">
            <el-date-picker v-model="formTool.shp_first_ord_time" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="最后下单时间" prop="">
            <el-date-picker v-model="formTool.shp_last_ord_time" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="最后访问时间" prop="">
            <el-date-picker v-model="formTool.last_visit_time" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="phone">
            <MyButton type="primary" text="查询" @click="goSearch" />
            <el-button size="small" @click="formToolReset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="body-tools-right">
        <!-- <MyButton type="primary" text="导出" @click="goExport" /> -->
      </div>
    </div>
    <div class="body-table">
      <MyTable :table-data="tableData"
        max-height="calc(100% - 44px)"
        :index="false"
        :selection="false"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
        @sort-change="sortChange"
        @handleSelectionChange="currentChange">
        <template slot="type" slot-scope="scope">
          <span>{{ scope.row.type=='ios'?'苹果系统':'安卓系统' }}</span>
        </template>
        <template slot="tools" slot-scope="scope">
          <div style="display:flex">
            <el-link type="primary" :underline="false" size="small" @click="goLink(scope.row)">查看详情</el-link>
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>

import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable';
import { getAreaTree } from '@/api/shopmange/index';
import { getListByType } from "@/api/businessManage";
import { queryGoodsSalesEcharts, queryGoodsSalesEchartsExport } from "@/api/statistics";
export default {
  name:'ReportMerchantDetail',
  components: { MyButton, MyTable },
  data() {
    return {
      shopId:'',
      shopName:'',
      formTool: {
        erp_id:'', //-- 客户ERP ID
        pay_shop_name:'', //-- 客户名称
        pay_concat_phone:'', //-- 客户电话
        // pay_concat_name, //-- 联系人
        pay_district_name:[], //-- 客户所在区域
        pay_shop_type_name:'', //-- 客户类型
        // order_cnt, // -- 订单量
        // qty, //-- 商品销量
        // amount, //-- 采购额（元）
        // avg_order_amount, //-- 客单价（元）
        shp_first_ord_time:'', //-- 首次下单时间
        shp_last_ord_time:'', //-- 最后下单时间
        last_visit_time:'', //-- 最后访问时间
      },
      typesOptions: [],
      tableData: [],
      tableOption: [
        { label: '运营部门', prop: 'dept_name', minWidth: '180px' },
        { label: '运营人员及联系方式', prop: 'dept_concat_name', minWidth: '160px' },
        { label: '客户ID', prop: 'erp_id', width: '116px' },
        { label: '客户名称', prop: 'pay_shop_name', minWidth: '120px' },
        { label: '客户电话', prop: 'pay_concat_phone', width: '110px' },
        { label: '联系人', prop: 'pay_concat_name', width: '90px' },
        { label: '客户所在地区', prop: 'pay_district_name', minWidth: '180px' },
        { label: '客户类型', prop: 'pay_shop_type_name', width: '90px' },
        { label: '订单量', prop: 'order_cnt', width: '90px',sortable:'custom' },
        { label: '商品销量', prop: 'qty', width: '90px',sortable:'custom' },
        { label: '采购额(元)', prop: 'amount', width: '110px',sortable:'custom' },
        { label: '客单价(元)', prop: 'avg_order_amount', width: '110px',sortable:'custom' },
        { label: '首次下单时间', prop: 'dept_first_ord_time', width: '150px',sortable:'custom' },
        { label: '最后下单时间', prop: 'dept_last_ord_time',sortable:'custom', width: '150px',sortable:'custom' },
        { label: '最后访问时间', prop: 'last_visit_time',sortable:'custom', width: '150px',sortable:'custom' },
        { label: '操作', prop: 'tools', slot: true, width: '80px',fixed: 'right' }
      ],
      page: { total: 10, current: 1, size: 10 },
      sortStatus:'up',
      sortType:'1',// 排序字段: 订单量 1,商品数量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
      cascaderProps: {
        label:'rname',
        value:'id',
      },
      areaTreeData:[],
    };
  },
  // computed: {},
  // watch: {},
  created() {
    let query = this.$route.query;
    if(query.shopId && query.shopName){
      this.shopId = query.shopId;
      this.shopName = query.shopName;
      this.getArea();
      this.getShopTypes();
      this.initData();
    }else{
      this.goBack();
    }
  },
  mounted() {},
  methods: {
    goLink(el){
      let url = `/reportMerchant/reportMerchant-reportDetailMore?shopId=${el.pay_shop_id}&shopName=${el.pay_shop_name}&deptId=${el.dept_id}&deptName=${el.dept_name}`;
      this.$router.push(url);
    },
    goSearch(){
      this.sortStatus = 'up';
      // this.sortType = '1';
      this.initData();
    },
    sortChange(el){
      const { column, prop, order } = el; // order释义：descending:降,ascending:升,为空时代表不选中
      console.log(column, prop, order)
      let propNames = {
        order_cnt: { label: '订单量', value: '1' },
        qty: { label: '商品数量', value: '2' },
        amount: { label: '采购额', value: '3' },
        avg_order_amount: { label: '客单价', value: '4' },
        shp_first_ord_time: { label: '首次下单时间', value: '5' },
        shp_last_ord_time: { label: '最后下单时间', value: '6' },
        last_visit_time: { label: '最后访问时间', value: '7' },
      }
      // 执行条件搜索操作
      this.sortStatus = order == 'descending'?'down':'up';
      // sortType:'1',// 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
      this.sortType = (order && propNames[prop]) ? propNames[prop].value : '1';
      this.initData();
    },
    //获取整个省市区的树
    getArea () {
      getAreaTree({ level: 3 }).then(res => {
        this.areaTreeData = res.data || [];
      })
    },
    areaChange(val){
      const el = this.$refs.areaRef.getCheckedNodes();
      let areas = []
      if(val.length>0){
        areas = el[0].pathNodes.map(li=>{
          return { id: li.value, name: li.label }
        })
      }
      console.log(areas);
    },
    getShopTypes () {
      // 获取客户/商户类型列表
      getListByType({
        type: 0, //0 客户类型  1商户类型
      }).then((res) => {
        this.typesOptions = res.data?res.data.map(li=>{
          return { value: li.typeCode, label: li.typeName }
        }):[]
      });
    },
    // goExport(){
    //   let obj = this.getParams('export');
    //   queryGoodsSalesEchartsExport(obj,'客户报表列表'); //执行文件获取及下载
    // },
    formToolReset () {
      this.formTool = {
        erp_id:'', //-- 客户ERP ID
        pay_shop_name:'', //-- 客户名称
        pay_concat_phone:'', //-- 客户电话
        // pay_concat_name, //-- 联系人
        pay_district_name:[], //-- 客户所在区域
        pay_shop_type_name:'', //-- 客户类型
        // order_cnt, // -- 订单量
        // qty, //-- 商品销量
        // amount, //-- 采购额（元）
        // avg_order_amount, //-- 客单价（元）
        shp_first_ord_time:'', //-- 首次下单时间
        shp_last_ord_time:'', //-- 最后下单时间
        last_visit_time:'', //-- 最后访问时间
      }
      // this.$refs.formTool.resetFields()
      this.initData();
    },
    currentChange(){},
    initData(){
      this.page.current = 1;
      this.getList();
    },
    getList(){
      // console.log('getList-重新加载数据')
      let obj = this.getParams(this.sortStatus);
      let totalObj = this.getParams('total');
      queryGoodsSalesEcharts(obj).then(list=>{
        this.tableData = list || [];
      })
      queryGoodsSalesEcharts(totalObj).then(list=>{
        // 获取总条数
        let total = 0;
        if(list && list.length>0){
          total = parseInt(list[0].cnt);
        }
        this.page.total = total;
      })
    },
    getParams(status = 'up'){
      const { current, size } = this.page;
      const { erp_id, pay_shop_name, pay_concat_phone, pay_district_name, pay_shop_type_name, shp_first_ord_time, shp_last_ord_time, last_visit_time } = this.formTool;
      // formTool: {
      //   erp_id:'', //-- 客户ERP ID
      //   pay_shop_name:'', //-- 客户名称
      //   pay_concat_phone:'', //-- 客户电话
      //   pay_district_name:[], //-- 客户所在区域
      //   pay_shop_type_name:'', //-- 客户类型
      //   shp_first_ord_time:'', //-- 首次下单时间
      //   shp_last_ord_time:'', //-- 最后下单时间
      // },
      let priviceCode = '';
      let cityCode = '';
      let areaCode = '';
      if(pay_district_name && pay_district_name.length>0){
        priviceCode = pay_district_name[0];
        cityCode = pay_district_name[1];
        if(pay_district_name.length>2){
          areaCode = pay_district_name[2];
        }
      }

      let firstSTime = '';
      let firstETime = '';
      if(shp_first_ord_time && shp_first_ord_time.length>0){
        firstSTime = shp_first_ord_time[0].replaceAll('-', '');
        firstETime = shp_first_ord_time[1].replaceAll('-', '');
      }
      let EndSTime = '';
      let EndETime = '';
      if(shp_last_ord_time && shp_last_ord_time.length>0){
        EndSTime = shp_last_ord_time[0].replaceAll('-', '');
        EndETime = shp_last_ord_time[1].replaceAll('-', '');
      }
      let vistSTime = '';
      let vistETime = '';
      if(last_visit_time && last_visit_time.length>0){
        vistSTime = last_visit_time[0].replaceAll('-', '');
        vistETime = last_visit_time[1].replaceAll('-', '');
      }
      let types = {
        up: 102, down:103, total:104, // export:57
      }
      let type = types[status];
      let params = [
        this.shopId,// 商户ID"1606205771220635650"
        '','','','',
        erp_id || '',erp_id || '',// ERPID
        pay_shop_name || '',pay_shop_name || '', // 客户名称
        pay_concat_phone || '',pay_concat_phone || '', // 客户电话
        priviceCode,priviceCode, // 省编码
        cityCode,cityCode, // 市编码
        areaCode,areaCode, // 区编码
        pay_shop_type_name || '',pay_shop_type_name || '', // 客户类型编码
        firstSTime,firstSTime, // 首次下单时间(开始时间)
        firstETime,firstETime, // 首次下单时间(结束时间)
        EndSTime,EndSTime, // 最后下单时间(开始时间)
        EndETime,EndETime, // 最后下单时间(结束时间)
        vistSTime,vistSTime, // 最后访问时间(开始时间)
        vistETime,vistETime, // 最后访问时间(结束时间)
      ]
      let paramsMore = [
        this.sortType, // 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
        size, // 每页行数
        (current - 1)*size, // 第几行开始
      ]
      return { type, params: (status=='up' || status == 'down') ? [ ...params, ...paramsMore ] : params}
    },
    goBack () {
      // console.log('go back');
      // this.$router.push("/reportMerchant/reportMerchant-reportList");

      // this.$router.go(-1)：后退+刷新；
      // this.$router.go(0)：刷新；
      // this.$router.go(1) ：前进
      this.$router.back(); //:后退
      // this.$router.back(0) 刷新；
      // this.$router.back(1)：前进
    },
  },
  // beforeCreate() { },
  // beforeMount() { },
  // beforeUpdate() { },
  // updated() { },
  // beforeDestroy() { },
  // destroyed() { },
  // activated() { },
}
</script>
<style lang='scss' scoped>
.body{
  &-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    &-left{
      width: calc(100% - 90px);
      line-height: 1;
      font-size: 26px;
      font-weight: 600;
      color: #000;
    }
    &-right{
      width: 90px;
      text-align: right;
    }
  }
  &-tools{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 16px;
    &-left{
      width: calc(100% - 90px);
    }
    &-right{
      width: 90px;
      text-align: right;
    }
    ::v-deep .el-form{
      &-item{
        margin-bottom: 6px !important;
      }
    }
  }
  &-table{
    height: calc(100% - 180px);
  }
}
</style>
